import React from "react";
import Select from "react-select"; 

function ProductSpecifications({
    formData,
    handleChange,
    handleSpecificationSelect,
    config,
    errors ,
    colors = [],
    sizes = []  
}) {
    const specifications = config?.specifications || [];
    if (!specifications.length) return null;
    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Product Specifications</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {specifications.map((item) => {        
                        const { key, label, type = "text", options, required } = item;
                       if (type === 'select') {
                            let isMulti = false;
                            let finalOptions = [];
                            if (options === 'colors') {
                                finalOptions = colors.map(c => ({ value: c.id, label: c.color_name }));
                                isMulti = true;
                            } else if (options === 'sizes') {
                                finalOptions = sizes.map(s => ({ value: s.id, label: s.size_name }));
                                isMulti = true;
                            } else if (Array.isArray(options)) {
                                finalOptions = options.map(opt => ({ value: opt, label: opt }));
                                isMulti = false;
                            }
                            const currentValue = formData[key] || [];
                            const selectedValue = isMulti 
                                ? finalOptions.filter(option => currentValue.includes(option.value))
                                : finalOptions.find(option => option.value === currentValue);
                            return (
                                 <div className="col-md-6 mb-3" key={key}>
                                    <label className="form-label">
                                        {label} {required && <span className="text-danger">*</span>}
                                    </label>
                                    <Select
                                        isMulti={isMulti}
                                        options={finalOptions}
                                        value={selectedValue}
                                        onChange={(selected) => {
                                            handleSpecificationSelect(key, selected, isMulti);
                                        }}
                                        placeholder={`Select ${label}...`}
                                        className={errors?.[key] ? "is-invalid" : ""}
                                    />
                                    {errors?.[key] && (
                                        <div className="invalid-feedback">{errors[key]}</div>
                                    )}
                                </div>
                            );
                        }
                        if (type === 'textarea') {
                            return (
                                <div className="col-md-12 mb-3" key={key}>
                                    <label className="form-label">
                                        {label} {required && <span className="text-danger">*</span>}
                                    </label>
                                    <textarea
                                        className={`form-control ${errors?.[key] ? "is-invalid" : ""}`}
                                        rows={item.rows || 3}
                                        name={key}
                                        value={formData[key] || ""}
                                        onChange={handleChange}
                                        placeholder={`Enter ${label}`}
                                    />
                                    {errors?.[key] && (
                                        <div className="invalid-feedback">{errors[key]}</div>
                                    )}
                                </div>
                            );
                        }
                        return (
                            <div className="col-md-6 mb-3" key={key}>
                                <label className="form-label">
                                    {label} {required && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type={type === 'number' ? 'number' : 'text'}
                                    className={`form-control ${errors?.[key] ? "is-invalid" : ""}`}
                                    name={key}
                                    value={formData[key] || ""}
                                    onChange={handleChange}
                                    placeholder={`Enter ${label}`}
                                />
                                {errors?.[key] && (
                                    <div className="invalid-feedback">{errors[key]}</div>
                                )}
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
}

export default ProductSpecifications;